(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/poker/loggedin.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/poker/loggedin.js'); 'use strict';

svs.player_login.views.poker.Loggedin = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.poker_complete(data);
  },

  templateContext() {
    svs.utils.url.refreshQueryString();
    return {
      viewData: {
        loggedIn: Boolean(svs.utils.url.queryString.at)
      }
    };
  },

  onAttach() {
    svs.utils.url.navigate(this.model.get('returnUrl'));
  }

});
 })(window);